export const defaultState = () => ({
  countries: [],
  country: null,
  timezones: [],
  momentLocale: null,
  momentDateFormat: null,
  momentTimeFormat: null,
  supportedLanguages: [],
  defaultLanguage: null
});

const state = defaultState();

export default state;
